module.exports = __webpack_public_path__ + "img/google.f38b9510.png";